<template>
  <footer>
    footer here
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
